import { render, staticRenderFns } from "./DomainNameserversView.vue?vue&type=template&id=7d5386dc&"
import script from "./DomainNameserversView.vue?vue&type=script&lang=js&"
export * from "./DomainNameserversView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d5386dc')) {
      api.createRecord('7d5386dc', component.options)
    } else {
      api.reload('7d5386dc', component.options)
    }
    module.hot.accept("./DomainNameserversView.vue?vue&type=template&id=7d5386dc&", function () {
      api.rerender('7d5386dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/domains/DomainNameserversView.vue"
export default component.exports